import React, { useState, useEffect } from 'react';
import Title from '../../components/title/Title';
import SubTitle from '../../components/subTitle/SubTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { BE_URL_2, httpGet } from '../../http';
import { formatNumber, getYear, getCurrentDate, getExpeditionDate, formatDateMin } from '../../misc';
import './Retencion.css';
import { Link } from 'react-router-dom';
import { Alert, Spinner } from 'react-bootstrap';
import Button from '../../components/button/Button';

const Fecha = (props) => {
    return(
        <div className='fecha-container'>
            <div>{props.label}</div>
            <input type="date" id="fecha" name={props.name} value={props.value} onChange={props.onChange} max={props.max} />
        </div>
    );
}

const Retencion = (props) => {

    const [ estado, setEstado ] = useState({
        empresa: {
            nit: '',
            razonSocial: '',
            nombreAlterno: ''
        },
        proveedor: {
            nit: '',
            razonSocial: '',
            tel: '',
            email: ''
        },
        loading: true,
        error: {}
    });

    const [max, setMax] = useState('');

    useEffect(() => {

       
        console.log(JSON.parse(sessionStorage.getItem('estado')));

        let newEstado = JSON.parse(sessionStorage.getItem('estado'));
        const proveedor = JSON.parse(sessionStorage.getItem('proveedor'));
        const estado2 = JSON.parse(sessionStorage.getItem('estado'));
        newEstado.proveedor = proveedor;
        console.log(newEstado);
        
        setEstado(newEstado);       

        const type = props.history.location.state.tipo;
        const tipo = {
            codigo: props.history.location.state.tipo.tipo,
            titulo: props.history.location.state.tipo.descripcion,
            periodoGravable: 'Año gravable: ' + getYear(1),
            url: BE_URL_2 + '/api/v1/retenciones?empresa=' + sessionStorage.getItem('companyId') + '&nit=' + proveedor.nit + '&cuenta=' + props.history.location.state.tipo.cuenta + '%',
            ciudad: props.history.location.state.tipo.ciudadRetencion,
            fechaDesde: '',
            fechaHasta: '',
            visible: false
        };
        
        
        setRetencion({
            ...retencion,
            empresa: estado2.empresa,
            tipo: tipo,
            reteIva: false,
        });
        
        console.log("TIPO", type.tipo);
        if (type.tipo === 1)
            getMaxDateYearly();
        else {
            getMaxDate();
        }
        
    }, []);

    const getReteFuente = async () => {
        setRetencion({
            ...retencion,
            loading: true,
            tipo: {
                ...retencion.tipo,
                visible: true,
            }
        });

        console.log("URL:");
        console.log(retencion.tipo.url);

        const proveedor = JSON.parse(sessionStorage.getItem('proveedor'));
        console.log(retencion.tipo.url  + '&fecha1=' + retencion.tipo.fechaDesde + "&fecha2=" + retencion.tipo.fechaHasta);
        const certificado = await httpGet(retencion.tipo.url  + '&fecha1=' + retencion.tipo.fechaDesde + "&fecha2=" + retencion.tipo.fechaHasta);

        console.log('CERTIFICADO');
        console.log(certificado);
        
        let totalBase = 0;
        let totalRetencion = 0;

        if(certificado.data.length > 0){
            const pr = {
                nit: certificado.data[0]['nit'],
                razonSocial: certificado.data[0]['razonSocial'],
                digitoVerificacion: certificado.data[0]['digitoVerificacion'],
                direccion: certificado.data[0]['direccion'],
                ciudad: certificado.data[0]['ciudad']
            }
    
            for( const reg of certificado.data){
                totalBase = totalBase + reg.base;
                totalRetencion = totalRetencion + reg.valorRetencion;
            }
    
            let total = {
                base: totalBase,
                retencion: totalRetencion
            }
    
            if((certificado !== null) && (certificado !== undefined)){
                const type = props.history.location.state.type;
                setRetencion({
                    ...retencion,
                    empresa: estado.empresa,
                    proveedor: pr,
                    data: certificado.data,
                    total: total,
                    loading: false,                
                    tipo: {
                        ...retencion.tipo,
                        periodoGravable: 'Periodo gravable del: ' + retencion.tipo.fechaDesde + ' al: ' + retencion.tipo.fechaHasta,
                        visible: true,
                    }
                });
            }
        } else {
            setRetencion({
                ...retencion,
                loading: false,                
                showNoDataMsg: true,
                tipo: {
                    ...retencion.tipo,
                    visible: true
                }
            });
        }
        
    }

    const [retencion, setRetencion ] = useState(
        {
            proveedor: {
                codigo: '',
                deigitoVerificacion: '',
                descripcion: '',
                direccion: '',
                ciudad: ''
            },
            data: [],
            total: {
                base: 0,
                retencion: 0
            },
            tipo: {
                codigo: '',
                titulo: '',
                periodoGravable: '',
                ciudad: '',
                fechaDesde: '',
                fechaHasta: '',
                visible: false
            },
            loading: false,
            showNoDataMsg: false,
            error: {}
        }
    );

    const setType = () => {
        const type = props.history.location.state.type;
        let tipo = {};
        const proveedor = JSON.parse(sessionStorage.getItem('proveedor'));
        const estado2 = JSON.parse(sessionStorage.getItem('estado'));

        switch(type){
            case 1:
                tipo = {
                    codigo: type,
                    titulo: 'Certificado de retención en la fuente',
                    periodoGravable: 'Año gravable: ' + getYear(1),
                    url: BE_URL_2 + '/api/v1/retenciones?nit=' + proveedor.nit + '&cuenta=2365%',
                    ciudad: estado2.empresa.ciudad,
                    fechaDesde: '',
                    fechaHasta: '',
                    visible: false
                }
                break;
            case 3:
                tipo = {
                    codigo: type,
                    titulo: 'Certificado de retención Industria, Comercio y Avisos (I.C.A.)',
                    periodoGravable: 'Año gravable: ' + getYear(1) ,
                    url: BE_URL_2 + '/api/v1/retenciones?nit=' + proveedor.nit + '&cuenta=' + props.history.location.state.ciudad.cuenta + '%',
                    ciudad: props.history.location.state.tipo.ciudadRetencion,
                    fechaDesde: '',
                    fechaHasta: '',
                    visible: false
                }
                break;
            case '2':
                tipo = {
                    codigo: type,
                    titulo: 'Certificado de retención I.V.A.',
                    periodoGravable: 'Periodo gravable del: ' + retencion.tipo.fechaDesde + ' al: ' + retencion.tipo.fechaHasta,
                    url: BE_URL_2 + '/api/v1/retenciones?nit=' + proveedor.nit + '&cuenta=2367%',
                    ciudad: estado2.empresa.ciudad,
                    visible: false
                }
                break;
            default:
                tipo = {
                    codigo: type,
                    titulo: 'Certificado de retención I.V.A.',
                    periodoGravable: 'Periodo gravable del: ' + retencion.tipo.fechaDesde + ' al: ' + retencion.tipo.fechaHasta,
                    url: BE_URL_2 + '/api/v1/retenciones?nit=' + proveedor.nit + '&cuenta=2367%',
                    ciudad: estado2.empresa.ciudad,
                    visible: false
                }
        }

        return tipo;
    }

    const handleChange = (e) => {
        setRetencion({
            ...retencion,
            tipo: {
                ...retencion.tipo,
                [e.target.name]: e.target.value
            }
        });
    }

    const handleClick = () => {
        console.log("FECHA DESDE:")
        console.log(retencion.tipo.fechaDesde.replace(/-/g, ''));
        console.log("FECHA HASTA:")
        console.log(retencion.tipo.fechaHasta.replace(/-/g, ''));

        if((retencion.tipo.fechaDesde.length > 0) && (retencion.tipo.fechaHasta.length > 0)){
            getReteFuente();
        } else {
            alert("Por favor ingrese las fechas correctamente.")
        }
    }

    const getMaxDate = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();

        let maxDate = new Date(year + '-' + month + '-' + '01');
        
        console.log(parseInt(day));
        if (parseInt(day) < 7) {
            maxDate.setMonth(maxDate.getMonth() - 1);
        }

        maxDate.setDate(maxDate.getDate() - 1);
        //maxDate.setDate(maxDate.getDate - 1)
        console.log('MAX DATE', formatDateMin(maxDate).replaceAll('-', '/').trim());
        setMax(formatDateMin(maxDate).replaceAll('/', '-').trim());
    }

    const getMaxDateYearly = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();

        let maxDate = new Date(year + '-' + month + '-' + '01');
        
        console.log(parseInt(day));

        if ((parseInt(month) === 1) && (parseInt(day) < 15)) {
            console.log((parseInt(maxDate.getMonth()) - 1));
            maxDate.setFullYear(parseInt(maxDate.getFullYear()) - 1)
            maxDate.setMonth(0);
        } else {
            maxDate.setMonth(0);
        }
        
        console.log(maxDate);

        maxDate.setDate(maxDate.getDate() - 1);
        //maxDate.setDate(maxDate.getDate - 1)
        console.log("MAX DATE", formatDateMin(maxDate).replaceAll('/', '-').trim());
        setMax(formatDateMin(maxDate).replaceAll('/', '-').trim());
    }

    return(
        <div className='page-container'>
            <Title>{ retencion.tipo.titulo }</Title>
            
            <div className='page-body'>

                <br/>
                <>
                    <Alert variant='warning'>Señor proveedor tenga en cuenta que la información del mes actual y el mes anterior puede variar si aún no se ha realizado el cierre contable; por favor tener presente las fechas mencionadas más adelante para la generación de su certificado. </Alert>
                    <Alert variant='warning'>El certificado anual de retención en la fuente estará disponible a partir del 15 de marzo, los certificados bimensuales estarán disponibles a partir del día 7 del mes siguiente al mes que termina el periodo. Si tiene dudas por favor comuníquese con el departamento contable.</Alert>
                    <div className='retencion-fechas-container'>
                        <Fecha label="Fecha inicial:" name='fechaDesde' value={retencion.tipo.fechaDesde} onChange={handleChange} max={max} /> 
                        <Fecha label="Fecha final:" name='fechaHasta' value={retencion.tipo.fechaHasta} onChange={handleChange} max={max} />
                        <Button onClick={handleClick}>Consultar</Button>
                    </div>
                </>
                               
                {retencion.tipo.visible &&
                <>
                {retencion.loading ?
                <div className='loading-spinner'>
                    <Spinner animation="border" variant="primary" />
                </div>
                :
                retencion.showNoDataMsg ?
                <>
                    <br />
                    <br />
                    <Alert variant='warning'>No se encontró información con los parametros de busqueda.</Alert>
                </>
                :
                <>
                <br/>
                <br/>
                <SubTitle>{ retencion.tipo.titulo } { estado.empresa.razonSocial }</SubTitle>
                <div>
                    <div>{ estado.empresa.razonSocial }</div>
                    <div>{ estado.empresa.nit }-{estado.empresa.digitoVerificacion}</div>
                </div>
                <br />
                <div>
                    { estado.empresa.ciudad }
                </div>
                <br />
                <SubTitle>{ retencion.tipo.periodoGravable }</SubTitle>
                <div>
                    <div><span className='info-title'>Retenido: </span><span>{ retencion.proveedor.razonSocial }</span></div>
                    <div><span className='info-title'>N.I.T.: </span><span>{ retencion.proveedor.nit }-{ retencion.proveedor.digitoVerificacion }</span></div>
                    <div><span className='info-title'>Dirección </span><span>{ retencion.proveedor.direccion }</span></div>
                    <div><span className='info-title'>Ciudad </span><span>{ retencion.proveedor.ciudad }</span></div>
                    <br />
                    <br />
                    <div><span className='info-title'>Ciudad donde se practicó la retención: </span><span>{ retencion.tipo.ciudad }</span></div>
                    <div><span className='info-title'>Ciudad donde se consignó la retención: </span><span>{ retencion.tipo.ciudad }</span></div>
                </div>
                <br />
                <table className='info-table tabla-retencion'>
                    <thead>
                        <tr>
                            <th>CONCEPTO</th>
                            <th>TASA</th>
                            <th>BASE</th>
                            <th>RETENCION</th>
                        </tr>
                    </thead>
                    <tbody>
                        { 
                            retencion.data.map(
                                rete => {
                                    return(
                                        <tr key={rete.id}>
                                            <td>{ rete.cuentaDescripcion }</td>
                                            <td>{ rete.tasa }%</td>
                                            <td>${ formatNumber(rete.base) }</td>
                                            <td>${ formatNumber(rete.valorRetencion) }</td>
                                        </tr>
                                    );
                                }
                            )
                        }
                        <tr>
                            <td colSpan='2'>TOTAL</td>
                            <td>${ formatNumber(retencion.total.base) }</td>
                            <td>${ formatNumber(retencion.total.retencion) }</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <br />
                <div>
                    <div className='retencion-footer-text'>Fecha de generación { getCurrentDate() }</div>
                    <div className='retencion-footer-text'>Fecha de expedición { getExpeditionDate(retencion.tipo.fechaHasta, retencion.tipo.codigo) }</div>
                    < br/>
                    <div>
                        <span>Descargar </span>
                        <span className='pdf-icon-container'><Link style={{ color: 'red' }} to={{ pathname: '/portal/certificado-pdf', state: { retencion: retencion } }}><FontAwesomeIcon className='view-icon' icon={faFilePdf} /></Link></span>
                    </div>
                </div>
                </>
                }
                </>
                }
            </div>
            
        </div>
    );
}

export default Retencion;
